import type { PopupData } from 'webapp-types';

import CommonPopupsDrawerComponent from 'webapp/components/common/popups/drawer';
import GoalsInsightsComponent from 'webapp/components/goals/insights/index';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class GoalsInsightsDrawerPopupComponent extends PopupInnerModalComponent<PopupData.Goal.InsightsDrawer> {
	get model() {
		return this.popupData.model;
	}

	get icon() {
		return this.model.isObjectiveType ? 'Flag' : 'Target';
	}

	get drawerArgs() {
		return {
			title: this.popupData.title,
			onClose: () => {
				this.close();
			},
		};
	}
	<template>
		<CommonPopupsDrawerComponent @icon={{this.icon}} @onClose={{this.drawerArgs.onClose}}>
			<:header>
				<div class="text">{{this.drawerArgs.title}}</div>
			</:header>
			<:content>
				<div id="page-goals-insights">
					<GoalsInsightsComponent @model={{this.model}} />
				</div>
			</:content>
		</CommonPopupsDrawerComponent>
	</template>
}
